import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import UpdateDetailsForm from '../forms/UpdateDetailsForm'
import globals from '../globals'

class MyDetails extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            profile: {}
        }
    }

    componentDidMount () {
        DataSource.getData('/api/getProfile?type=profile-data', result => {
            this.setState(result)
            this.setState({ isLoaded: true })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        return (
            <div className='invoices module' style={{ overflow: 'visible' }}>
                <Heading title='Update my details' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    <div className='row'>
                        <div className='col-12 col-md-8 offset-md-2 text-center'>
                            <p>You can update your account contact details here. For your security, you’ll need to enter the authentication code which we will send to the mobile phone number attached to your Exetel account. Once you’ve entered the security code you can update your account details.</p>
                        </div>
                        <div className='col-12 col-md-8 offset-md-2'>
                            <UpdateDetailsForm
                                fields={this.state.profile}
                                isVerified={this.props.isVerified}
                                handleVerificationSuccess={this.props.handleVerificationSuccess}
                                handleSuccess={() => globals.pushEvent('ChangeDetailsSubmit')}
                            />
                            <div className='my-3'>
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

export default MyDetails



// WEBPACK FOOTER //
// ./resources/js/modules/MyDetails.js